// extracted by mini-css-extract-plugin
export default {"product-summary":"ProductsList_product-summary__uZyB7"};